"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _reactPolyglot = require("react-polyglot");

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _redux = require("../../types/redux");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nextSortDirection(direction) {
  switch (direction) {
    case _redux.SortDirection.Ascending:
      return _redux.SortDirection.Descending;

    case _redux.SortDirection.Descending:
      return _redux.SortDirection.None;

    default:
      return _redux.SortDirection.Ascending;
  }
}

function sortIconProps(sortDir) {
  return {
    type: 'chevron',
    direction: sortIconDirections[sortDir],
    size: 'xsmall'
  };
}

const sortIconDirections = {
  [_redux.SortDirection.Ascending]: 'up',
  [_redux.SortDirection.Descending]: 'down'
};
const SortItem = (0, _styledBase.default)("button", {
  target: "e12k9syt0",
  label: "SortItem"
})(_netlifyCmsUiDefault.buttons.button, ";max-width:100%;text-overflow:ellipsis;display:inline-block;text-align:center;color:white;background-color:#313d3e;border-radius:unset;border-top-right-radius:4px;border-top-left-radius:4px;padding:4px 0px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function getSortDisplayName(sortType) {
  if (sortType === undefined) {
    return "Title";
  }

  switch (sortType) {
    case 'Publish Date':
      return 'Status';

    case 'Updated On':
      return 'Saved';

    case 'Author':
      return 'Last Edits';

    default:
      return sortType;
  }
}

function SortControl(_ref) {
  let {
    t,
    fields,
    onSortClick,
    sort
  } = _ref;
  const hasActiveSort = sort === null || sort === void 0 ? void 0 : sort.valueSeq().toJS().some(s => s.direction !== _redux.SortDirection.None);
  return fields.map(field => {
    const sortDir = sort === null || sort === void 0 ? void 0 : sort.getIn([field.key, 'direction']);
    const isActive = sortDir && sortDir !== _redux.SortDirection.None;
    const nextSortDir = nextSortDirection(sortDir);
    const fieldName = getSortDisplayName(field.label);
    return (0, _core.jsx)(SortItem, {
      key: field.key,
      onClick: () => onSortClick(field.key, nextSortDir),
      isActive: isActive
    }, fieldName, isActive && (0, _core.jsx)(_netlifyCmsUiDefault.Icon, sortIconProps(sortDir)));
  });
}

var _default = (0, _reactPolyglot.translate)()(SortControl);

exports.default = _default;